/* oxlint-disable react/rules-of-hooks */
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectIsFormValid,
  selectIsNewbuilding,
  selectEstimationTarget,
  selectFormFields,
  selectsRedirectLink,
} from '../../../selectors';

import { getSubmitAction, getValidateAction } from '../helpers';
import { useActions, useGetTrackAddMyHomeObject } from '../../../hooks';
import { navigateToPage } from '@cian/valuation-utils-component';

export const useSubmitClickHandler = () => {
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);
  const filters = useSelector(selectFormFields);

  const redirectLink = useSelector(selectsRedirectLink);
  const isFormValid = useSelector(selectIsFormValid);

  const trackMyHomeAddObjectButtonClick = useGetTrackAddMyHomeObject({ estimationTarget, filters, isNewbuilding });

  const { deleteErrorMessage } = useActions();

  const submitAction = getSubmitAction();
  const validateAction = getValidateAction();

  React.useEffect(() => {
    if (isFormValid) {
      submitAction();
    }
  }, [isFormValid]);

  React.useEffect(() => {
    if (redirectLink) {
      navigateToPage(redirectLink);
    }
  }, [redirectLink]);

  return React.useCallback(() => {
    trackMyHomeAddObjectButtonClick();
    deleteErrorMessage();
    validateAction();
  }, [estimationTarget, isNewbuilding, filters]);
};
